// Prüft, ob der Browser die Aufnahme überhaupt leisten kann.
//
// Hintergrund: Systemton per getDisplayMedia gibt es auf macOS erst ab Chrome 141
// UND macOS 14.2 – Apple hat Systemton für Fremd-Apps erst dann freigegeben.
// Safari kann es überhaupt nicht, in keiner Version. Statt die Nutzer in eine
// stumme Aufnahme laufen zu lassen, sagen wir das vorher klar.

function parseVersion(str) {
  return (str || '').split('.').map((n) => parseInt(n, 10) || 0);
}

// Vergleicht Versionen wie "14.2.1" – true, wenn a >= b
function atLeast(a, b) {
  const va = parseVersion(a);
  const vb = parseVersion(b);
  for (let i = 0; i < Math.max(va.length, vb.length); i++) {
    const x = va[i] || 0;
    const y = vb[i] || 0;
    if (x > y) return true;
    if (x < y) return false;
  }
  return true;
}

// Liefert genauere Angaben als der User-Agent-String, aber nur in Chromium-Browsern.
async function highEntropy() {
  const uaData = navigator.userAgentData;
  if (!uaData || !uaData.getHighEntropyValues) return null;
  try {
    return await uaData.getHighEntropyValues(['platform', 'platformVersion']);
  } catch {
    return null;
  }
}

export async function checkCapabilities() {
  const ua = navigator.userAgent;
  const isChromium = Boolean(navigator.userAgentData) || /Chrome|Chromium|Edg\//.test(ua);
  const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
  const isFirefox = /firefox|fxios/i.test(ua);

  if (!window.isSecureContext) {
    return {
      ok: false,
      title: 'Unsichere Verbindung',
      message:
        'Aufnahmen sind nur über HTTPS möglich. Bitte die Seite über https:// öffnen ' +
        '(localhost ist beim Entwickeln ebenfalls erlaubt).',
    };
  }

  if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia) {
    return {
      ok: false,
      title: 'Browser nicht unterstützt',
      message:
        'Dieser Browser kann keine Bildschirm-/Systemton-Aufnahme starten. ' +
        'Bitte Google Chrome oder Microsoft Edge verwenden.',
    };
  }

  if (isSafari || isFirefox) {
    return {
      ok: false,
      title: isSafari ? 'Safari wird nicht unterstützt' : 'Firefox wird nicht unterstützt',
      message:
        (isSafari
          ? 'Safari kann den Systemton eines Meetings grundsätzlich nicht mitschneiden – '
          : 'Firefox kann den Systemton nicht zuverlässig mitschneiden – ') +
        'ohne ihn würde nur deine eigene Stimme aufgenommen. Bitte Google Chrome oder ' +
        'Microsoft Edge verwenden.',
    };
  }

  // macOS: Systemton gibt es erst ab 14.2 (Sonoma). Darunter liefert der Browser
  // zwar eine Aufnahme, aber ohne den Ton der Gegenseite.
  const info = await highEntropy();
  if (info && info.platform === 'macOS' && info.platformVersion) {
    if (!atLeast(info.platformVersion, '14.2')) {
      return {
        ok: false,
        title: 'macOS-Version zu alt',
        message:
          `Für die Systemton-Aufnahme wird macOS 14.2 oder neuer benötigt (erkannt: ${info.platformVersion}). ` +
          'Ohne Update würde nur das Mikrofon aufgenommen – der Gesprächspartner wäre nicht zu hören.',
      };
    }
  }

  return { ok: true, isChromium };
}

// Ob das schwebende Coach-Fenster möglich ist (Chrome/Edge). Kein Grund zu blockieren –
// ohne die Funktion wird der Coach einfach in der Seite angezeigt.
export function supportsPictureInPicture() {
  return typeof window !== 'undefined' && 'documentPictureInPicture' in window;
}
